export default __webpack_public_path__ + "../staticImages/sprite-UPS-2x.png";